import './Areas.scss';
import React from 'react';
import { Pin } from '../components/Icons';

const areas = [
  'Ladner',
  'Tsawwassen',
  'North Delta',
  'Surrey',
  'White Rock',
  'Richmond',
  'Vancouver',
  'Burnaby',
  'New Westminster',
  'Langley',
  'Cloverdale',
  'Coquitlam',
];

const d = (ms: number) => ({ '--delay': `${ms}ms` } as React.CSSProperties);

export function Areas() {
  return (
    <section id="areas" className="section section--grey areas">
      <div className="container">
        <div className="head head--center">
          <span className="eyebrow reveal">Where we work</span>
          <h2 className="reveal" style={d(80)}>
            Serving Delta and the Lower Mainland.
          </h2>
        </div>
        <ul className="areas__grid">
          {areas.map((a, i) => (
            <li key={a} className="reveal" style={d(i * 40)}>
              <Pin /> {a}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
